import { Component } from '@angular/core';

@Component({
  selector: 'app-terms-content',
  imports: [],
  templateUrl: './terms-content.component.html',
  styleUrl: './terms-content.component.css',
})
export class TermsContentComponent {

}
